import { createContext as o, useContext as t } from "react";
import { a } from "./vanilla-CSAfDK5R.js";
const e = () => ({
  openAtom: a(!1)
}), n = o(
  e()
), m = () => t(n);
export {
  n as N,
  e as c,
  m as u
};
//# sourceMappingURL=NavigationDropdownState-CxCC5dTJ.js.map
